import { Perm, Roles } from "../../../auth/permissions";

export const MainNav = [
    // {
    //     icon: 'pe-7s-graph',
    //     label: 'Dashboard',
    //     to: '/dashboard',
    //     requiredPerms: [Perm.Report_View],
    // },
    
    // {
    //     icon: 'pe-7s-timer',
    //     label: 'Lịch sử hoạt động',
    //     to: '/activity-log',
    //     requiredPerms: [Perm.Report_Log],
    // },
    {
        icon: 'pe-7s-user',
        label: 'Danh sách người dùng',
        to: '/users',
        requiredPerms: [Perm.User_View],
    },
    {
        icon: 'pe-7s-settings',
        label: 'Quản lý vai trò',
        to: '/roles',
        requiredRoles: [Roles.Admin],
    },
];

export const ScheduleNav = [
    {
        icon: 'pe-7s-date',
        label: 'Lập lịch khám',
        to: '/schedule',
        requiredPerms: []
    },
    {
        icon: 'pe-7s-note2',
        label: 'Danh sách lịch hẹn',
        to: '/appointment',
        requiredPerms: [Perm.Appointment_View]
    },
    {
        icon: 'pe-7s-note2',
        label: 'Yêu cầu khám với chuyên gia',
        to: '/appointment/request',
        requiredPerms: [Perm.Appointment_Request_Manage]
    },
    {
        icon: 'pe-7s-users',
        label: 'Đăng ký theo tổ chức',
        to: '/organization',
        requiredPerms: [Perm.Organization_View]
    },
]

export const ClinicNav = [
    {
        icon: 'pe-7s-config',
        label: 'Thông tin phòng khám',
        to: '/clinic',
        requiredPerms: []
    },
];

export const DoctorNav = [
    {
        icon: 'pe-7s-user',
        label: 'Thông tin bác sĩ',
        to: '/bac-si',
        requiredPerms: []
    },
];